import { Path, useWatch } from 'react-hook-form';
import { FieldNames } from '../fieldNames';
import { MicrosConfigurationFormSchema } from '../formProps';

const useDetailedBillingFieldName: Path<MicrosConfigurationFormSchema> =
    FieldNames.detailedBillingConfigurationUseDetailedBilling;
const useMultiDepartmentFieldName: Path<MicrosConfigurationFormSchema> =
    FieldNames.detailedBillingConfigurationUseMultiDepartment;

export const useDetailedBillingConfigurationFlags = () => {
    const [isDetailedBillingEnabled, isMultiDepartmentEnabled] = useWatch<
        MicrosConfigurationFormSchema,
        [typeof useDetailedBillingFieldName, typeof useMultiDepartmentFieldName]
    >({
        name: [useDetailedBillingFieldName, useMultiDepartmentFieldName],
    });

    return { isDetailedBillingEnabled, isMultiDepartmentEnabled };
};
